import { UserTypeConstants } from '../types/UserTypeConstants';

export const AdminActions = {
    registerAdmin,
    registerAdminSuccess,
    registerAdminFailiure,
    getAllAdmin,
    getAllAdminSuccess,
    getAllAdminFailiure,
    getUserById,
    getUserByIdSuccess,
    getUserByIdFailiure,
    udpateAdmin,
    getAllHCPAdmin,
    updateSecretQuestion,
    updateSecretQuestionSuccess,
    getSecretQuestionsAnswers,
    getSecretQuestionsAnswersSuccess,
    getSecretQuestionsAnswersFailiure,
    clearAdmin
};

function registerAdminSuccess(data) {
    return { type: UserTypeConstants.ADMIN_REGISTER_SUCCESS, data };
}

function registerAdminFailiure(action) {
    return { type: UserTypeConstants.ADMIN_REGISTER_FAILURE, message:action };
}

function registerAdmin(user) {
    return { type: UserTypeConstants.ADMIN_REGISTER_REQUEST, user };
}

function udpateAdmin(user) {
    return { type: UserTypeConstants.ADMIN_UPDATE_REQUEST, user };
}

function getAllAdmin() {
    return { type: UserTypeConstants.ADMIN_GETALL_REQUEST };
}

function getAllHCPAdmin() {
    return { type: UserTypeConstants.ADMIN_GETALL_HCP_REQUEST };
}

function getAllAdminSuccess(data) {
    return { type: UserTypeConstants.ADMIN_GETALL_SUCCESS,data };
}

function getAllAdminFailiure(action) {
    return { type: UserTypeConstants.ADMIN_GETALL_FAILURE , message:action };
}

function getUserById(id){
    return { type: UserTypeConstants.GET_USER_BY_ID_REQUEST,id };
}
function getUserByIdSuccess(data){
    return { type: UserTypeConstants.GET_USER_BY_ID_SUCCESS,data };
}
function getUserByIdFailiure(message){
    return { type: UserTypeConstants.GET_USER_BY_ID_FAILIURE, message:message };
}

function updateSecretQuestion(data){
    return { type: UserTypeConstants.UPDATE_SECRET_QUESTION_REQUEST, data };
}

function getSecretQuestionsAnswers(id){
    return { type: UserTypeConstants.GET_SECRET_QUESTION_REQUEST, id };
}

function getSecretQuestionsAnswersSuccess(data){
    return { type: UserTypeConstants.GET_SECRET_QUESTION_SUCCESS, data };
}

function updateSecretQuestionSuccess(){
    return { type: UserTypeConstants.UPDATE_SECRET_QUESTION_SUCCESS };
}
function getSecretQuestionsAnswersFailiure(){
    return { type: UserTypeConstants.GET_SECRET_QUESTION_FAILIURE };
}

function clearAdmin(){
    return { type: UserTypeConstants.CLEAR_ADMIN };
}